<template>
  <div v-if="loadingStore.isLoading" class="overlay">

    <svg viewBox="0 0 230 195" class="logo-svg">
      <!-- 회색 배경 로고 -->
      <image href="@/assets/images/unpeace_gray.svg" width="230" height="195" grayscale="100%" />

      <!-- 파도 클립 마스크 정의 -->
      <defs>
        <clipPath id="waveClip">
          <path :d="wavePath" />
        </clipPath>
      </defs>

      <!-- 파란 로고에 마스크 적용 -->
      <image
        href="@/assets/images/unpeace_blue.svg"
        width="230"
        height="195"
        clip-path="url(#waveClip)"
      />
    </svg>
    
    <p class="message">{{ loadingStore.message }}</p>
  </div>
</template>

<script setup>
import { loadingStore } from '@/utils/LoadingStore';
import { ref, onMounted, watch } from 'vue';

const wavePath = ref('');
const width = 230;
const height = 195;

let time = 0;
let baseY = height;
let requestId = null;

function getWavePath(amplitude, frequency, offsetY) {
  const points = [];
  const waveHeight = offsetY;
  const step = 10;

  for (let x = 0; x <= width; x += step) {
    const y = Math.sin((x + time) * frequency) * amplitude + waveHeight;
    points.push(`${x},${y}`);
  }

  return `M0,${height} L${points.join(' ')} L${width},${height} Z`;
}

function animateWave() {
  time += 1;
  baseY -= 1.5;
  if (baseY < 0) baseY = 0;

  wavePath.value = getWavePath(8, 0.05, baseY);
  requestId = requestAnimationFrame(animateWave);
}

function resetWave() {
  if (requestId) {
    cancelAnimationFrame(requestId);
    requestId = null;
  }

  time = 0;
  baseY = height;
  wavePath.value = '';
}

watch(() => loadingStore.isLoading, (newVal) => {
  if (newVal) {
    resetWave();
    animateWave();
  } else {
    resetWave(); // 로딩 종료 시 루프 정지
  }
});

onMounted(() => {
  if (loadingStore.isLoading) {
    animateWave();
  }
});
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* 반투명 배경 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px); /* 배경 블러 처리 */
  user-select: none;
}

.message {
  margin-top: 16px;
  font-size: 1.2rem;
  color: #467AEB;
  font-weight: bold;
}

.logo-svg {
  width: 230px;
  height: 195px;
}
</style>